import TimingDiagramView from './TimingDiagramView'

export default TimingDiagramView
